import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@as/cotopaxi';
import { BasketStatus, deliveryDay, } from '@as-react/common-types';
import { makeGetBasketDeliveryInfoState, makeGetBasketStatusState, makeGetBasketTotalQuantityState, } from '../redux/basket/selectors/BasketSelector';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DeliveryConditionsBanner } from '../components/delivery-conditions-banner/DeliveryConditionsBanner';
import { ENABLED_DELIVERY_PROMISES } from '../constants/DeliveryConstants';
dayjs.extend(utc);
const getDefaultCutOffUTCTime = (date, exceptions, days) => {
    const today = date.format('YYYY-MM-DD');
    const isExceptionalDay = exceptions === null || exceptions === void 0 ? void 0 : exceptions.find(exception => exception.date === today);
    if (isExceptionalDay) {
        return isExceptionalDay.cutOffUTC;
    }
    const todaysDayOfWeek = date.day();
    return days.find(day => deliveryDay[day.day] === todaysDayOfWeek).cutOffUTC;
};
const isNextDayDeliveryEligible = (messages) => {
    return messages && Object.keys(messages).some(key => ENABLED_DELIVERY_PROMISES.includes(key));
};
const DeliveryConditionsBannerContainer = ({ basketNddEligibleAbove, basketNddEligibleBelow, basketNotNddEligibleAbove, basketNotNddEligibleBelow, default: defaultState, emptyBasketAfterCutoff, emptyBasketBeforeCutoff, nextDayDeliveryInfo: { days, exceptions, thresholdFreeDelivery }, }) => {
    const productAmount = useSelector(makeGetBasketTotalQuantityState());
    const deliveryInfo = useSelector(makeGetBasketDeliveryInfoState());
    const [condition, setCondition] = useState();
    const basketStatus = useSelector(makeGetBasketStatusState());
    const now = dayjs.utc();
    const cutoffTime = (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.deliveryPromiseCutoff) || getDefaultCutOffUTCTime(now, exceptions, days);
    const amountUntilFreeDelivery = deliveryInfo.hasDeliveryMessage && deliveryInfo.deliveryMessages && deliveryInfo.amountUntilFreeDelivery
        ? deliveryInfo.amountUntilFreeDelivery
        : thresholdFreeDelivery;
    useEffect(() => {
        var _a, _b;
        if (basketStatus === BasketStatus.LOADING || !cutoffTime)
            return;
        const deadlineHour = parseInt((_a = cutoffTime.split(':')) === null || _a === void 0 ? void 0 : _a[0], 10);
        const deadlineMinute = parseInt((_b = cutoffTime.split(':')) === null || _b === void 0 ? void 0 : _b[1], 10);
        const deadline = now.set('hour', deadlineHour).set('minute', deadlineMinute).set('second', 0);
        const hasFreeDelivery = amountUntilFreeDelivery <= 0;
        setCondition(() => {
            let tmpState = basketNotNddEligibleBelow;
            if (productAmount === 0) {
                tmpState = now.isAfter(deadline) ? emptyBasketAfterCutoff : emptyBasketBeforeCutoff;
            }
            else if (isNextDayDeliveryEligible(deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.deliveryMessages)) {
                tmpState = hasFreeDelivery ? basketNddEligibleAbove : basketNddEligibleBelow;
            }
            else if (hasFreeDelivery) {
                tmpState = basketNotNddEligibleAbove;
            }
            return (tmpState === null || tmpState === void 0 ? void 0 : tmpState.message) ? tmpState : defaultState;
        });
    }, [basketStatus, amountUntilFreeDelivery, deliveryInfo.deliveryMessages]);
    if (!condition || !condition.message)
        return null;
    return (_jsxs(Box, { mobile: { spacing: { paddingTop: 1, paddingBottom: 1 } }, children: [(condition === emptyBasketAfterCutoff || condition === basketNotNddEligibleBelow) && (_jsx(DeliveryConditionsBanner, { message: condition.message, icon: condition.icon, link: condition.link, amountUntilFreeDelivery: amountUntilFreeDelivery })), (condition === emptyBasketBeforeCutoff || condition === basketNddEligibleBelow) && (_jsx(DeliveryConditionsBanner, { message: condition.message, cutoffTime: cutoffTime, icon: condition.icon, link: condition.link, amountUntilFreeDelivery: amountUntilFreeDelivery })), condition === basketNddEligibleAbove && (_jsx(DeliveryConditionsBanner, { message: condition.message, cutoffTime: cutoffTime, icon: condition.icon, link: condition.link })), (condition === basketNotNddEligibleAbove || condition === defaultState) && (_jsx(DeliveryConditionsBanner, { message: condition.message, icon: condition.icon, link: condition.link }))] }));
};
export default DeliveryConditionsBannerContainer;
